import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  requestDocTypesStatus,
  requestDocumentUpload,
  requestEmpStatus,
  requestGetEmpStatus,
  setResetEmpStatusState,
} from "../../Redux/EmployeeStatusState/empStatusActionCreator";
import LOCAL_KEYS, { parseLocalStorageJSON } from "../../helpers/Localstorage";
import Loader from "../../components/Loader";
import { MdDelete, MdDownload, MdEdit, MdArrowBack } from "react-icons/md";
import { Formik, Form } from "formik";
import TextInput from "../../components/TextInput";
import { statusOptions } from "../../Constants";
import CustomDropdown from "../../components/CustomDropdown";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { requestUserById } from "../../Redux/UserState/UserActionCreator";
import CustomDataTable from "../../components/CustomDataTable";
import {
  requestDownloadFileAction,
  setResetStatedownloadFile,
} from "../../Redux/FileState/uploadFileActionCreator";
import DocumentModal from "../EmployeeStatus/DocumentModal";
import { toast } from "react-toastify";
import { FaFile } from "react-icons/fa";
import CustomDatePicker from "../../components/CustomDatePicker";
import MuiDatePicker from "../../components/MuiDatePicker";
import CustomToolTip from "../../components/ToolTip";
import {
  DocumentTextIcon,
  UserIcon,
  CalendarIcon,
  ClockIcon,
  CheckCircleIcon,
  DocumentIcon,
  UploadIcon,
  DownloadIcon,
  TrashIcon,
} from "@heroicons/react/outline";
import Hoc from "../../components/HOC";
import FormButton from "../../components/FormButton";
import Swal from "sweetalert2";
import AlertsCard from "../../components/AlertsCard";

const DocumentsForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const dispatch = useDispatch();
  const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
  const getEmpStatusReducer = useSelector((state) => state.GetEmpStatusReducer);
  const userByIdReducer = useSelector((state) => state.UserByIdReducer);
  const DocumentTypes = useSelector((state) => state.GetDocTypesReducer);
  const DownloadFileReducer = useSelector((state) => state.DownloadFileReducer);
  const documentUploadReducer = useSelector(
    (state) => state.DocumentUploadReducer
  );
  const empStatusReducer = useSelector((state) => state.EmpStatusReducer);
  const [docModelOpen, setDocModelOpen] = useState({
    isOpen: false,
    title: "",
  });
  
  const [listOfDocs, setListOfDocs] = useState([]);
  const [formValues, setFormValues] = useState({
    userId: "",
    fullName: "",
    userStatus: "",
    startDate: "",
    endDate: "",
    statusCode: "",
  });

  const documentInitialValues = {
    issueDate: "",
    expiryDate: "",
    documentType: "",
    others: "",
    file: null,
  };

  const submittedValuesFn =( values) =>{

    let submittedValues = {}

    if(values.documentType !== "OTHER") {
      submittedValues = {
        issueDate: moment(values.issueDate).format("yyyy-MM-DD"),
        expiryDate: moment(values.expiryDate).format("yyyy-MM-DD"),
        others: values.others,
        documentType: values.documentType,
        file: values.file,
      }
    }
    else if (values.documentType === "OTHER") {
      submittedValues = {
        
        others: values.others,
        documentType: values.documentType,
        file: values.file,
      }
      if(values.issueDate) {
        submittedValues.issueDate = moment(values.issueDate).format("yyyy-MM-DD")
      }
      if(values.expiryDate) {
        submittedValues.expiryDate = moment(values.expiryDate).format("yyyy-MM-DD")
      }
    }
    return submittedValues
  }
  

  // Color scheme to match dashboard
  const themeColors = {
    primary: {
      light: "#6366f1", // Indigo-500
      main: "#4f46e5", // Indigo-600
      dark: "#4338ca", // Indigo-700
    },
    secondary: {
      light: "#a855f7", // Purple-500
      main: "#9333ea", // Purple-600
      dark: "#7e22ce", // Purple-700
    },
    success: {
      main: "#16a34a", // Green-600
    },
    warning: {
      main: "#d97706", // Amber-600
    },
    error: {
      main: "#dc2626", // Red-600
    },
  };

  const AlertListReducer = useSelector((state) => state.AlertListReducer);

  const isDocumentExpired = (documentType, expiryDate) => {
    const expiredDoc = AlertListReducer?.response?.documents?.find(
      doc => doc.documentType === documentType && doc.status === "Expired"
    );
    return !!expiredDoc;
  };

  const columns = [
    {
      name: "Document Type",
      selector: (row) => row.documentType,
      sortable: true,
      cell: (row) => (
        <div className="flex items-center  ">
          <DocumentIcon className="h-5 w-5 text-indigo-500 mr-2" />
          <span className="truncate">{row.documentType}</span>
        </div>
      ),
    },
    {
      name: "Issue Date",
      selector: (row) => {
        if (row && row.issueDate) {
          try { 
            return moment(row.issueDate).format("MM-DD-YYYY");
          } catch (e) {
            return "N/A";
          }
        }
        return "N/A";
      },
      sortable: true,
      hide: "sm",
      cell: (row) => (
        <div className="flex items-center">
          <CalendarIcon className="h-4 w-4 text-gray-500 mr-2" />
          <span className="truncate">
            {row.issueDate ? moment(row.issueDate, "MM-DD-YYYY").format("MM-DD-YYYY") : "N/A"}
          </span>
        </div>
      ),
    },
    {
      name: "Expiry Date",
      selector: (row) => {
        if (row && row.expiryDate) {
          try {
            return moment(row.expiryDate, "MM-DD-YYYY").format("MM-DD-YYYY");
          } catch (e) {
            return "N/A";
          }
        }
        return "N/A";
      },
      sortable: true,
      hide: "sm",
      cell: (row) => {
        const isExpired = row.expiryDate ? moment(row.expiryDate, "MM-DD-YYYY").isBefore(moment(), 'day') : false;
        const isExpiringThisMonth = row.expiryDate ? 
          moment(row.expiryDate, "MM-DD-YYYY").isSame(moment(), 'month') && 
          !moment(row.expiryDate, "MM-DD-YYYY").isBefore(moment(), 'day') : false;
        
        return (
          <div className="flex items-center truncate">
            <ClockIcon className={`h-4 w-4 mr-2 ${isExpired || isExpiringThisMonth ? 'text-red-500' : 'text-gray-500'}`} />
            <span className="truncate">
              {row.expiryDate ? moment(row.expiryDate, "MM-DD-YYYY").format("MM-DD-YYYY") : "N/A"}
            </span>
          </div>
        );
      },
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-4">
          <button
            onClick={() => {
              Swal.fire({
                title: "Are you sure?",
                text: `Do you want to delete ${row.fileName}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
              }).then((result) => {
                if (result.isConfirmed) {
                  handleClick(id, row.fileId, "delete", row.fileName);
                }
              });
            }}
            className="p-2 rounded-full hover:bg-red-50 text-red-500"
            data-tip
            data-for={`delete-${row.fileId}`}
          >
            <TrashIcon className="h-5 w-5" />
            <CustomToolTip id={`delete-${row.fileId}`} title="Delete" />
          </button>
          <button
            onClick={() =>
              handleClick(id, row.fileId, "download", row.documentType)
            }
            className="p-2 rounded-full hover:bg-indigo-50 text-indigo-500"
            data-tip
            data-for={`download-${row.fileId}`}
          >
            <DownloadIcon className="h-5 w-5" />
            <CustomToolTip id={`download-${row.fileId}`} title="Download" />
          </button>
        </div>
      ),
    },
  ];

  const handleDocumentModal = () => {
    let typeOfDocs = getEmpStatusReducer?.response?.files?.map(
      (file) => file.documentType
    );
    let result = DocumentTypes?.response?.filter(
      (value) => !typeOfDocs?.includes(value)
    );
    setListOfDocs(result);
    setDocModelOpen({ isOpen: true, title: "Add Document" });
  };

  const handleSubmit = (values) => {
    if (isEdit) {
      dispatch(
        requestEmpStatus({
          userId: id,
          userStatus: values.userStatus,
          startDate: values.startDate,
          endDate: values.endDate,
          statusCode: values.statusCode,
        })
      );
    }
    // dispatch(requestGetEmpStatus(id ? id : userDetails?.id));
  };

  const submitDocument = (values) => {
    const submittedValues = {
      userId: id || userDetails?.id,
      issueDate: values.issueDate ? moment(values.issueDate).format("yyyy-MM-DD") : null,
      expiryDate: values.expiryDate ? moment(values.expiryDate).format("yyyy-MM-DD") : null,
      others: values.others,
      documentType: values.documentType,
      file: values.file,
    };

    dispatch(requestDocumentUpload(submittedValues));
  };
  


  const handleClose = () => {
    setDocModelOpen({ isOpen: false, title: "" });
    setListOfDocs([]);
  };

  const handleClick = (id, fileId, action, fileName) => {
    dispatch(
      requestDownloadFileAction(id || userDetails?.id, fileId, action, fileName)
    );
  };

  const transformedFiles = getEmpStatusReducer?.response?.files.map((file) => {
    const documentType = file.documentType;
    const cleanedDocumentType = documentType.startsWith("OTHER-")
      ? documentType.replace("OTHER-", "") // Remove the "OTHER-" prefix
      : documentType;
  //   return { ...file, documentType: cleanedDocumentType };
  // });
    return { 
      ...file, 
      documentType: cleanedDocumentType,
      issueDate: file.issueDate || null,
      expiryDate: file.expiryDate || null
    };
  }) || [];

  useEffect(() => {
    if (getEmpStatusReducer?.response && !getEmpStatusReducer?.loading) {
      setFormValues(getEmpStatusReducer?.response?.employeeStatus);
    }

    if (getEmpStatusReducer?.error && !getEmpStatusReducer?.loading) {
      if (userDetails?.acctType !== "USER") {
        if (!userByIdReducer?.byIdLoading && userByIdReducer?.byIdResponse) {
          setFormValues({
            ...formValues,
            fullName: `${userByIdReducer?.byIdResponse?.firstName} ${userByIdReducer?.byIdResponse?.lastName}`,
          });
        }
      } else {
        setFormValues({
          ...formValues,
          fullName: `${userDetails?.firstName} ${userDetails?.lastName}`,
        });
      }
    }
  }, [getEmpStatusReducer]);

  useEffect(() => {
    dispatch(setResetEmpStatusState());
    
    const fetchData = () => {
      dispatch(requestGetEmpStatus(id ? id : userDetails?.id));
      dispatch(requestDocTypesStatus());
      if (userDetails?.acctType !== "USER") {
        dispatch(requestUserById(id));
      }
    };

    fetchData();

    return () => {
      dispatch(setResetEmpStatusState());
    };
  }, [ id, userDetails?.id, userDetails?.acctType]);

  useEffect(() => {
    if (getEmpStatusReducer?.error && !getEmpStatusReducer?.loading) {
      dispatch(setResetEmpStatusState());
    }
  }, [getEmpStatusReducer]);

  useEffect(() => {
    if (DocumentTypes?.error && !DocumentTypes?.loading) {
      // Silent error handling
    }
  }, [DocumentTypes]);

  useEffect(() => {
    if (empStatusReducer?.response && !empStatusReducer?.loading) {
      toast.success("Status updated successfully");
      setIsEdit(false);
      dispatch(setResetEmpStatusState());
      dispatch(requestGetEmpStatus(id ? id : userDetails?.id));
    }
  }, [empStatusReducer, id, userDetails?.id]);

 // Define outside useEffect
const retryFetch = async (effectiveId, documentType, retries = 5, delay = 500) => {
  for (let i = 0; i < retries; i++) {
    await new Promise((res) => setTimeout(res, delay));

    await dispatch(requestGetEmpStatus(effectiveId, true));

    const updatedFiles = getEmpStatusReducer?.response?.files || [];

    const isDocPresent = updatedFiles.some(
      (file) => file.documentType === documentType
    );

    if (isDocPresent) {
      handleClose();
      return true; // success
    }
  }
  return false; // failed after retries
};

useEffect(() => {
  if (documentUploadReducer?.response && !documentUploadReducer?.loading) {
    const effectiveId = id || userDetails?.id;
    const documentType = documentUploadReducer.response.documentType;

    retryFetch(effectiveId, documentType);
  }
}, [documentUploadReducer]);

  

  useEffect(() => {
    if (!DownloadFileReducer?.loading && (DownloadFileReducer?.response || DownloadFileReducer?.error)) {
      const effectiveId = id || userDetails?.id;
  
      if (DownloadFileReducer?.error) {
        toast.error("Something went wrong");
      }
  
      if (DownloadFileReducer?.response && DownloadFileReducer?.action === "delete") {
        toast.success("File deleted successfully");
        dispatch(requestGetEmpStatus(effectiveId));
      }
  
      dispatch(setResetStatedownloadFile());
    }
  }, [DownloadFileReducer, id, userDetails?.id]);

  return (
    <div className="w-full h-[96vh] sm:h-[85vh] md:h-[92vh] lg:h-[96vh] overflow-y-auto sm:overflow-hidden px-5 py-3">
      <Loader
        isLoading={
          getEmpStatusReducer?.loading ||
          userByIdReducer?.byIdLoading ||
          empStatusReducer?.loading ||
          documentUploadReducer?.loading
        }
      />
      <AlertsCard />
      <DocumentModal
        initialValues={documentInitialValues}
        show={docModelOpen.isOpen}
        title={"Upload Documents"}
        onClose={handleClose}
        documentsList={listOfDocs || []}
        submitForm={submitDocument}
      />

      {/* Header */}
      <div className="mb-4 sticky top-0 bg-gradient-to-br from-gray-50 to-indigo-50 pt-2 pb-2 z-10">
        <div className="flex items-center gap-2">
          {userDetails?.acctType !== "USER" && userDetails?.acctType !== "User" && (
            <button
              type="button"
              className="text-primary hover:text-primaryDark"
              onClick={() => navigate("/manageemployee")}
            >
              <MdArrowBack size={24} />
            </button>
          )}
        </div>

        <div className="flex justify-end">
          {!isEdit && userDetails?.acctType !== "USER" && userDetails?.acctType !== "User" && (
            <button
              className="text-primary hover:text-primaryDark"
              onClick={() => setIsEdit(true)}
            >
              <MdEdit size={24} />
            </button>
          )}
        </div>
      </div>

      {/* User Status Form */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-3 sm:p-4 md:p-5 lg:p-6 mb-4">
        <Formik
          initialValues={{
            ...formValues,
            fullName:
              formValues?.fullName ||
              `${userByIdReducer?.byIdResponse?.firstName} ${userByIdReducer?.byIdResponse?.lastName}`,
          }}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({
            submitting,
            setFieldValue,
            values,
            errors,
            touched,
            handleChange,
          }) => (
            <Form method="post">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
                {/* Full Name */}
                <div>
                  <TextInput
                    type="text"
                    onChange={handleChange}
                    value={values?.fullName}
                    name="fullName"
                    disabled
                    legend
                    classes="w-full"
                    placeholder="Employee"
                  />
                </div>

                {/* User Status */}
                <div>
                  <CustomDropdown
                    value={
                      statusOptions?.find(
                        (status) => status.value === values.userStatus
                      ) || ""
                    }
                    customClasses="w-full text-left"
                    name="userStatus"
                    handleChange={(option) =>
                      setFieldValue("userStatus", option?.value)
                    }
                    placeholder="Select Status"
                    options={statusOptions}
                    handleGetOptionValue={(option) => option.value}
                    handleGetOptionName={(option) => option.label}
                    isDisabled={!isEdit}
                  />
                </div>

                {/* Status Code */}
                <div>
                  <CustomDropdown
                    value={
                      [
                        { label: "Active (A)", value: "A" },
                        { label: "Deactive (D)", value: "D" },
                        { label: "Closed (C)", value: "C" },
                      ]?.find((status) => status.value === values.statusCode) ||
                      ""
                    }
                    customClasses="w-full text-left"
                    name="statusCode"
                    handleChange={(option) =>
                      setFieldValue("statusCode", option?.value)
                    }
                    placeholder="Select Status Code"
                    options={[
                      { label: "Active (A)", value: "A" },
                      { label: "Deactive (D)", value: "D" },
                      { label: "Closed (C)", value: "C" },
                    ]}
                    handleGetOptionValue={(option) => option.value}
                    handleGetOptionName={(option) => option.label}
                    isDisabled={!isEdit}
                  />
                </div>

                {/* Start Date */}
                <div>
                  <MuiDatePicker
                    label="Start Date"
                    value={values?.startDate ? moment(values.startDate, "MM-DD-YYYY") : null}
                    onChange={(date) => {
                      if (date) {
                        setFieldValue("startDate", date.format("YYYY-MM-DD"));
                      }
                    }}
                    disabled={!isEdit}
                    maxDate={values?.endDate ? moment(values.endDate, "MM-DD-YYYY") : null}
                  />
                </div>

                {/* End Date */}
                <div>
                  <MuiDatePicker
                    label="End Date"
                    value={values?.endDate ? moment(values.endDate, "MM-DD-YYYY") : null}
                    onChange={(date) => {
                      if (date) {
                        setFieldValue("endDate", date.format("YYYY-MM-DD"));
                      }
                    }}
                    disabled={!isEdit}
                    minDate={
                      values?.startDate ? moment(values.startDate, "MM-DD-YYYY") : null
                    }
                  />
                </div>

                {/* Buttons - only show in edit mode */}
                {isEdit && (
                  <div className="flex items-end space-x-4 col-span-1 sm:col-span-2 lg:col-span-1">
                    <button
                      type="button"
                      onClick={() => setIsEdit(false)}
                      className="px-3 sm:px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-3 sm:px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl transition-colors"
                    >
                      Save Changes
                    </button>
                  </div>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>

      {/* Documents Table */}
      <div className="flex justify-end items-end mb-4 sm:mb-6 sticky top-[72px] sm:top-[80px] bg-gradient-to-br from-gray-50 to-indigo-50 pt-2 pb-2 z-10">
        <FormButton
          type="button"
          size="sm"
          onClick={handleDocumentModal}
          disabled={!getEmpStatusReducer?.response?.employeeStatus}
          className={`bg-primary hover:bg-blue-700 text-white transition-colors 
                      ${
                        !getEmpStatusReducer?.response?.employeeStatus
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
        >
          <UploadIcon className="h-4 w-4 sm:h-5 sm:w-5 mr-1" />
          <span className="text-sm sm:text-base">Upload Document</span>
        </FormButton>
      </div>
      <div className="mt-4 h-[calc(100vh-5px)] sm:h-[calc(100vh-200px)] md:h-[calc(100vh-260px)] lg:h-[calc(100vh-280px)] overflow-y-auto sm:overflow-hidden lg:overflow-y-auto">
      <CustomDataTable
          columns={columns}
          pagination={false}
          data={transformedFiles}
          fixedHeaderScrollHeight={"calc(100vh - 400px)"}
       
        />
      </div>
    </div>
  );
};

export default Hoc(DocumentsForm);
